import logo from './logo.jpg';
import appstore from './appstore.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <b>Strobot</b> is your strob in your phone.
        </p>
        <div>
          It reacts to the sound and turns on the flashlight.
        </div>
        <a
          className="App-link"
          href="https://apps.apple.com/ua/app/strobot/id1669373543?l=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={appstore} width={180} alt={"App Store"} />
        </a>
      </header>
    </div>
  );
}

export default App;
